/**
 * useCouponUsages
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'
import CouponUsagesContext from './coupon-usages-context'

const useCouponUsages = () => {
  const context = useContext(CouponUsagesContext)
  return context
}

export default useCouponUsages
